unit DepartmentType;
{

/* Initail. */

}
interface

uses
  JS,
  TypeType;

type
  TDepartmentType = class
  private
    fDepartmentKey: String;
    fCode: String;
    fName: String;
    fType: TTypeType;
    fActive: Boolean;
  public
    property Department: String read fDepartmentKey;
    property Code: String read fCode;
    property Name: String read fName;
    property DepartmentType: TTypeType read fType;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TDepartmentType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fDepartmentKey := String(JSObject_Type['departmentKey']);
    fCode := String(JSObject_Type['code']);
    fName := String(JSObject_Type['name']);
    fType := TTypeType.Create(TJSJSON.stringify(JSObject_Type['type']));
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
